export default{
	methods: {
		toggleExpansion(){
			this.is_expanded = !this.is_expanded;
		}
	}
}
